module.exports = __webpack_public_path__ + "static/images/0b2b04101353455ca5c711d0c059fbb2.png";